// extracted by mini-css-extract-plugin
export default {"moduleCart":"src-pages-SalesChannelContentEditor-SalesChannelContentPage-EditorPage-ModuleCart-css-module__moduleCart--KQxEW"};